import { render, staticRenderFns } from "./UserPayment.vue?vue&type=template&id=7af96472"
import script from "./UserPayment.vue?vue&type=script&lang=js"
export * from "./UserPayment.vue?vue&type=script&lang=js"
import style0 from "./UserPayment.vue?vue&type=style&index=0&id=7af96472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports